<div class="dashboard-admin">
  @if (banner(); as b) {
    <div class="alert" [class.alert-success]="b.type === 'success'" [class.alert-danger]="b.type === 'error'">{{ b.text }}</div>
  }

  <section class="da-section flex-shrink-0">
    <div class="da-section__head">
      <h2 class="da-h2" i18n="@@pdc.dashboard_admin.section.templates_widgets">Templates &amp; Widgets</h2>
    </div>
    <div class="row g-0">
      <!-- Templates -->
      <div class="da-section__sidebar col-md-4">
        <div class="d-flex justify-content-between align-items-start gap-3 mb-3">
          <span class="da-eyebrow" i18n="@@pdc.dashboard_admin.templates.heading">Templates</span>
          <button class="btn btn-xs btn-dark" (click)="openTemplateEditor()"><fa-icon [icon]="['fas','plus']"></fa-icon> <span i18n="@@pdc.dashboard_admin.action.new">New</span></button>
        </div>
        <ul class="list-unstyled d-flex flex-column gap-2 m-0">
          @for (t of templates(); track t.id) {
            <li>
              <button class="da-tpl d-flex align-items-center justify-content-between gap-2" [class.is-active]="t.id === selectedId()" (click)="selectTemplate(t.id)">
                <span class="da-tpl__info d-flex flex-column">
                  <span class="da-tpl__name">{{ t.name }}</span>
                  <span class="da-tpl__meta">{{ t.key }} · {{ t.visibility }}</span>
                </span>
                <span class="da-badge" [class.is-off]="!t.enabled">{{ t.enabled ? onLabel : offLabel }}</span>
              </button>
            </li>
          } @empty {
            <li class="da-empty" i18n="@@pdc.dashboard_admin.templates.empty">No templates.</li>
          }
        </ul>
      </div>

      <!-- Selected template -->
      <div class="da-section__main col-md-8">
        @if (selected(); as t) {
          <div class="d-flex justify-content-between align-items-start gap-3 mb-3">
            <div>
              <h3 class="da-h3 mb-0">{{ t.name }} <span class="da-dim">/ {{ t.key }}</span></h3>
              <div class="da-dim" i18n="@@pdc.dashboard_admin.template.meta">{{ widgets().length }} widget(s) · {{ t.visibility }}</div>
            </div>
            <div class="d-inline-flex gap-2">
              <button class="btn btn-xs btn-dark" (click)="openTemplateEditor(t)"><fa-icon [icon]="['fas','pen']"></fa-icon> <span i18n="@@pdc.dashboard_admin.action.edit">Edit</span></button>
              <button class="btn btn-xs btn-danger" (click)="deleteTemplate(t)" i18n-title="@@pdc.dashboard_admin.action.delete" title="Delete"><fa-icon [icon]="['fas','trash']"></fa-icon></button>
            </div>
          </div>

          <table class="table table-sm da-table">
            <thead>
              <tr>
                <th i18n="@@pdc.dashboard_admin.widgets.col.position">#</th>
                <th i18n="@@pdc.dashboard_admin.widgets.col.title">Title</th>
                <th i18n="@@pdc.dashboard_admin.widgets.col.type">Type</th>
                <th i18n="@@pdc.dashboard_admin.widgets.col.cols">Cols</th>
                <th class="text-end" i18n="@@pdc.dashboard_admin.widgets.col.actions">Actions</th>
              </tr>
            </thead>
            <tbody>
              @for (w of widgets(); track w.id; let i = $index) {
                <tr>
                  <td class="da-dim">{{ w.position }}</td>
                  <td>{{ w.title }}</td>
                  <td><code>{{ w.widget_type }}</code></td>
                  <td>{{ gridCols(w.grid) }}</td>
                  <td class="text-end d-flex gap-1 justify-content-end">
                    <button class="btn btn-xs btn-light" (click)="moveWidget(w, -1)" [disabled]="i === 0" i18n-title="@@pdc.dashboard_admin.action.move_up" title="Move up"><fa-icon [icon]="['fas','arrow-up']"></fa-icon></button>
                    <button class="btn btn-xs btn-light" (click)="moveWidget(w, 1)" [disabled]="i === widgets().length - 1" i18n-title="@@pdc.dashboard_admin.action.move_down" title="Move down"><fa-icon [icon]="['fas','arrow-down']"></fa-icon></button>
                    <button class="btn btn-xs btn-dark" (click)="openWidgetEditor(w)" i18n-title="@@pdc.dashboard_admin.action.edit" title="Edit"><fa-icon [icon]="['fas','pen']"></fa-icon></button>
                    <button class="btn btn-xs btn-danger" (click)="deleteWidget(w)" i18n-title="@@pdc.dashboard_admin.action.delete" title="Delete"><fa-icon [icon]="['fas','trash']"></fa-icon></button>
                  </td>
                </tr>
              } @empty {
                <tr><td colspan="5" class="da-empty" i18n="@@pdc.dashboard_admin.widgets.empty">No widgets yet — add one to get started.</td></tr>
              }
            </tbody>
          </table>

          <div class="mt-3">
            <button class="btn btn-sm btn-success" (click)="openWidgetEditor()"><fa-icon [icon]="['fas','plus']"></fa-icon> <span i18n="@@pdc.dashboard_admin.action.add_widget">Add widget</span></button>
          </div>
        } @else {
          <div class="da-empty da-empty--lg" i18n="@@pdc.dashboard_admin.template.select_prompt">Select a template to manage its widgets.</div>
        }
      </div>
    </div>
  </section>
</div>
